import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { gray, green, orange, red } from "../../../../utils/theme/colors.ts";

export const statusColors: any = {
  pending_upload: gray,
  pending_review: orange,
  valid: green,
  invalid: red,
};

export const mapping: any = {
  pending_upload: {
    title: "Pendiente",
    icon: <ExclamationCircleOutlined />,
  },
  pending_review: {
    title: "En revisión",
    icon: <ClockCircleOutlined />,
  },
  valid: {
    title: "Válido",
    icon: <CheckCircleOutlined />,
  },
  invalid: {
    title: "Inválido",
    icon: <CloseCircleOutlined />,
  },
  "tenant-pf": {
    title: "Documentos del Inquilino",
  },
  "tenant-pm": {
    title: "Documentos del Inquilino",
  },
  "tenant-pf-cja": {
    title: "Documentos del Inquilino",
  },
  "tenant-pm-cja": {
    title: "Documentos del Inquilino",
  },
  "guarantor-pf": {
    title: "Documentos del Fiador",
  },
  "guarantor-pf-cja": {
    title: "Documentos del Fiador",
  },
  "guarantor-pm": {
    title: "Documentos del Fiador",
  },
  "guarantor-pm-cja": {
    title: "Documentos del Fiador",
  },
  "guarantor-investigation-pf": {
    title: "Documentos del Fiador",
  },
  "guarantor-investigation-pm": {
    title: "Documentos del Fiador",
  },
  collateral: {
    title: "Inmueble en Garantía",
  },
  "lease-contract": {
    title: "Contrato Arrendamiento",
  },
  "lease-contract-pf": {
    title: "Contrato Arrendamiento",
  },
  "lease-contract-pm": {
    title: "Contrato Arrendamiento",
  },
  "landlord-pf": {
    title: "Documentos del Propietario",
  },
  "landlord-pm": {
    title: "Documentos del Propietario",
  },
  "owner-representative": {
    title: "Representante del Propietario",
  },
  "owner-representative-pm": {
    title: "Representante del Propietario",
  },
};
